import React, {
  useState,
  useEffect
} from 'react';
import "../App.css";
import { Link } from 'react-router-dom'
import {
  message,
  Form,
  Input,
  InputNumber,
  Button,
  Table,
  Divider
} from "antd"
import {
  db
} from '../firebase/firebase'
import { auth } from '../firebase';

const content = (
  <div>
    <p>Click me to manage units!</p>
  </div>
);

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ProjectList = () => {
  useEffect(() => {
    pullFromDB()

    auth.onAuthStateChanged((user) => {
      if (user) {
        setEmail(user.email)
      }
    });
  }, []);

  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState('');

  const [email, setEmail] = useState('');

  // this.state = {
  //   pendingMedia: "",
  //   data: [],
  //   ta: null,
  //   pa: null,
  //   aa: null,
  //   show: false,
  //   html: "<p>write some text here</p>",
  //   editorState: null,
  // };



  const makeid = (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }




  const addProject = async () => {

    await db.collection("projects").add({
      name: makeid(5),
      title: 'title',
    })
  }



  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    console.log('ff')
    form.setFieldsValue({
      filename: '',
      startdate: '',
      ...record,
    });
    setEditingKey(record.key);
    // this.state.show = true

  };

  const cancel = () => {
    setEditingKey('');
    // this.state.show = false

  };

  const deleteProject = (record) => {
    setEditingKey('');
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });

        try {


          // alert("OLD DATA: " + JSON.stringify(data[index]))
          // alert("the pa ta xa...: " + this.state.pa + this.state.ta + this.state.xa + this.state.ya + this.state.sa)

          // console.log("update! record.key: " + id + "todo id: " + data[id].id)

          await db
            .collection("projects")
            .doc(data[index].id).update({
              //to do in the future: maybe convert the user editted date into isostring format, so can store together
              // date: this.state.da,
              title: newData[index].title
            })
          message.success("Event " + newData[index].title + " successfully updated!");
          setData(newData)
          setEditingKey('');

        } catch (error) {
          message.error(error.message);

        }

      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  }

  const pullFromDB = () => {

    db.collection("projects").onSnapshot(snapshot => {
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });
      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }


      // Anytime the state of our database changes, we update state
      setData(data)

    })

  }

  const columns = [
    {
      title: 'Project Name',
      dataIndex: 'name',
      width: '18%',
      editable: false,
      render: (text, record) => {
        return (
          <div>
            {data[record.key].name}
          </div>
        );
      },
    },
    {
      title: 'Description',
      dataIndex: 'title',
      inputType: 'areaa',
      editable: true,
    },
    {
      title: '',
      dataIndex: 'buttons',
      width: '30%',
      render: (_, record) => {
        const editable = isEditing(record);
        return (
          <div>
            <Button><Link to={`/dashboard/projects/${data[record.key].id}/progress`}>Site Progress</Link></Button>
            <Divider type="vertical" />
            <Button><Link to={`/dashboard/projects/${data[record.key].id}/promotions`}>Promotions</Link></Button>
          </div>
        )
      },
    },
    {
      title: '',
      width: '20%',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button
              href=""
              onClick={e => {
                e.preventDefault()
                save(record.key)
              }}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </Button>
            {/* {email == "cc@cc.cc" &&
              <Button type="danger"
                style={{
                  marginRight: 8,
                }}
                onClick={() => cancel(record.key)}>Delete</Button>
            } */}
            <Button type="primary" onClick={() => deleteProject(record.key)}>Cancel</Button>
          </span>
        ) : (
          <div>
            <Button disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
            </Button>
          </div>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'title' ? 'areaa' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (

    <div>
      <h1 className="block">Projects</h1>

      <br></br>
      {email == 'cc@cc.cc' &&
        <div className="gutter-box">
          <Button onClick={() => addProject()}>Add</Button>
        </div>
      }

      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={{
            onChange: cancel,
            pageSize: 15
          }}
        />
      </Form>
    </div>
  );
};

export default ProjectList;





// WEBPACK FOOTER //
// ./src/views/projectlist.js